import cx from "clsx";
import ButtonTransparentV2 from "kreate-common/modules/kreate-ui/components/ButtonTransparentV2";
import React from "react";
import { MdCopyAll } from "react-icons/md";

import styles from "./index.module.scss";

import { useToast } from "@/modules/kreate-contexts/ToastContext";

type OwnProps = {
  className?: string;
  style?: React.CSSProperties;
  text: string | null | undefined;
};

type ForwardedProps = Omit<
  React.ComponentProps<typeof ButtonTransparentV2>,
  keyof OwnProps
>;

type Props = OwnProps & ForwardedProps;

export default function ButtonCopy({
  className,
  style,
  text,
  ...others
}: Props) {
  const { showMessage } = useToast();
  return (
    <ButtonTransparentV2
      className={cx(styles.container, className)}
      style={style}
      icon={<MdCopyAll />}
      disabled={text == null}
      onClick={() => {
        if (text == null) return;
        navigator.clipboard.writeText(text);
        showMessage({
          color: "success",
          title: "Copied to Clipboard",
          description: text,
        });
      }}
      {...others}
    />
  );
}
